import React from 'react';
import Modal from './Modal';
import { UPDATE_TITLE, UPDATE_SUMMARY } from '../updates';

/**
 * One-time "what's new" notice. App.js decides whether to show it (keyed in
 * localStorage per user + UPDATE_ID), so bumping UPDATE_ID in updates.js is
 * all it takes to surface the next one.
 */
export default function UpdateNotice({ onClose }) {
  return (
    <Modal title={UPDATE_TITLE} onClose={onClose} wide>
      <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 16, lineHeight: 1.5 }}>
        Thanks for testing the beta — here's what changed. Your data and settings carry over
        untouched.
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: 420, overflowY: 'auto' }}>
        {UPDATE_SUMMARY.map(item => (
          <div key={item.title}
            style={{ borderLeft: '2px solid var(--blue)', paddingLeft: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 3 }}>{item.title}</div>
            <div style={{ fontSize: 12.5, color: 'var(--text2)', lineHeight: 1.6 }}>{item.body}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 18, alignItems: 'center' }}>
        <div style={{ flex: 1, fontSize: 11, color: 'var(--text3)' }}>
          Something broken or missing? Use <strong>Feedback</strong> in the header.
        </div>
        <button className="btn btn-primary" onClick={onClose}>Got it</button>
      </div>
    </Modal>
  );
}
